import React from 'react';
import Footer from '../../Shared/Footer/Footer';
import Navbar from '../../Shared/Navbar/Navbar';
import About from '../../About/About';
import mish from '../../../assets/images/mish.png';
import './Home.css';
import html from '../../../assets/images/icons/html.png';
import css from '../../../assets/images/icons/css.png';
import js from '../../../assets/images/icons/js.png';
import bs from '../../../assets/images/icons/bootstrap.png';
import react from '../../../assets/images/icons/react.png';
import firebase from '../../../assets/images/icons/firebase.png';
import node from '../../../assets/images/icons/node.png';
import ex from '../../../assets/images/icons/express.png';
import mongo from '../../../assets/images/icons/mongodb_original_logo_icon_146424.png';
import work1 from '../../../assets/images/work-1.png';
import git from '../../../assets/images/github.svg';
import link from '../../../assets/images/link.svg';
import quato from '../../../assets/images/work-2.png';
import medi from '../../../assets/images/work-3.png';
import edu from '../../../assets/images/work-4.png';
import mac from '../../../assets/images/work-5.png';
import honda from '../../../assets/images/work-6.png';
import Contact from '../../Contact/Contact';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";

const Home = () => {
    return (
        <div>
            <Navbar />
            <div className='container home-banner'>
                <div className='row mx-auto'>
                    <div className='col-lg-6'>
                        <div className='img-div'>
                            <div className='main-img'>
                                <img className='w-100' src={mish} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6'>
                        <div className='banner-info'>
                            <h1 className='main-title'>Hi there!</h1>
                            <p className='main-info'>Enthusiastic developer eager to contribute to team success through hard work, attention to detail, and excellent organizational skills.</p>
                        </div>
                    </div>
                </div>
            </div>
            <ScrollAnimation animateIn="fadeOut">
                <div className='container section'>
                    <h2 className='title'>Tech I'm Familar With</h2>
                    <h1 className='title-bg'>TECH STACKS</h1>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px' }} src={html} alt="" />
                                <h5>HTML 5</h5>
                            </div>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={css} alt="" />
                                <h5>CSS 3</h5>
                            </div>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={js} alt="" /> <h5>JAVASCRIPT</h5>
                            </div>

                        </div>
                        <div className='col-lg-4'>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={bs} alt="" />
                                <h5>BOOTSTRAP</h5>
                            </div>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={react} alt="" />
                                <h5>REACT JS</h5>
                            </div>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={firebase} alt="" />
                                <h5>FIREBASE</h5>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={node} alt="" />
                                <h5>NODE JS</h5>
                            </div>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={ex} alt="" />
                                <h5>EXPRESS JS</h5>
                            </div>
                            <div className='d-flex justify-content-center align-items-center stack'>
                                <img style={{ width: '50px', padding: '5px' }} src={mongo} alt="" />
                                <h5>MONGODB</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
            <div className='container section'>
                <h2 className='title'>My Recent Works</h2>
                <h1 className='title-bg'>WEB APPS</h1>
                <div className='row'>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={work1} alt="" />
                            <h3 className='work-name'>Jetaway Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/jetaway'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/jetaway-app-client-side" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://jetaway.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={quato} alt="" />
                            <h3 className='work-name'>Quato Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/quato'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/quato-app-client-side" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://quato.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={medi} alt="" />
                            <h3 className='work-name'>Medisure Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/medisure'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/medisure-app" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://medisure.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={edu} alt="" />
                            <h3 className='work-name'>Educapedia Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/educapedia'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/educapedia-app" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://educapediaa.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={mac} alt="" />
                            <h3 className='work-name'>Macbook Pro Site</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/macbook'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/mac-book-pro" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://macbookpro.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={honda} alt="" />
                            <h3 className='work-name'>Honda CBR Site</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/honda'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/honda-crb" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://honda-cbrrr.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id='about'>
                <About />
            </div>
            <div id='contact'>
                <Contact />
            </div>
            <Footer />
        </div>
    );
};

export default Home;